"use client";

import ReactModal from "react-modal";
import { FiX } from "react-icons/fi";

import { PreviewToggle } from "@/components/PreviewToggle";
import { QRPreviewData, QRPreviewStyle } from "@/components/QRPreview";

import { ModalQRPreviewProps } from "@/modals/DashboardModals/types";
import { ModalProps } from "./types";

import "./styles.scss";

export const ModalQRPreview = (props: ModalProps<ModalQRPreviewProps>) => {
  const {
    data,
    isModalOpen,
    onCancelCallback,
    setIsModalOpen,
    previewType,
    setQrRaw,
    isQRInit,
    language,
    defaultPreviewTitle,
    previewButtonsTranslations,
  } = props;

  return (
    <ReactModal
      isOpen={isModalOpen}
      className="u-modal u-box u-box u-box--small u-text-center qr-preview__modal"
      overlayClassName="u-modal__overlay"
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={() => (onCancelCallback ? onCancelCallback() : setIsModalOpen(!isModalOpen))}
      ariaHideApp={false}
    >
      <FiX
        onClick={() => (onCancelCallback ? onCancelCallback() : setIsModalOpen(!isModalOpen))}
        size={20}
        className="u-modal__close"
      />
      <div className="qr-preview__modal-container">
        <PreviewToggle
          previewButtonsTranslations={previewButtonsTranslations}
          previewType={previewType}
          setPreviewType={data.setPreviewType}
          isQRActivated={data?.isQRActive}
          setQrRaw={setQrRaw}
          isModal
        />
        {previewType === "data" ? (
          <QRPreviewData
            data={data?.qrData}
            previewHome={data?.previewHome}
            previewTranslations={data?.previewTranslations}
            isQRInit={isQRInit}
            isModal
            language={language}
            defaultPreviewTitle={defaultPreviewTitle}
          />
        ) : (
          <QRPreviewStyle
            data={{
              ...data?.qrData,
              image: data?.raw && URL.createObjectURL(data?.raw),
            }}
          />
        )}
      </div>
    </ReactModal>
  );
};
